import { render, staticRenderFns } from "./shortPay.vue?vue&type=template&id=12b07419&scoped=true&"
import script from "./shortPay.vue?vue&type=script&lang=js&"
export * from "./shortPay.vue?vue&type=script&lang=js&"
import style0 from "./shortPay.vue?vue&type=style&index=0&id=12b07419&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b07419",
  null
  
)

export default component.exports